export const INBOUND = "COLLECTION";
export const OUTBOUND = "OUTBOUND";
